import dynamic from "next/dynamic";
const MultiProductsPricingComponent = dynamic(()=>import("./multi-products-pricing-component"));
import MultiProductsPricingConfig from "./multi-products-pricing-config";
import MultiProductsPricingAdvancedConfig from "./multi-products-pricing-advanced-config";
export default {
    MultiProductsPricingComponent,
    MultiProductsPricingConfig,
    MultiProductsPricingAdvancedConfig
};
